import { create } from 'zustand';
import { CollectionModel, emptyCollection } from 'model/collection/CollectionModels';

export interface CollectionState {

    collection: CollectionModel;
    updateCollection: (key: string, value: any) => void;
    setCollection: (collection: CollectionModel) => void;
    
    reset: () => void;

    endDateCache: string;
    setEndDateCache: (key: string) => void;
}

const useCollections = create<CollectionState>((set) => ({
    reset: () => set((state: CollectionState) => ({ 
        collection: emptyCollection(),
        visited: new Set(),
        violations: new Map() 
    })),
    collection: emptyCollection(),
    updateCollection: (key: string, value: any) => set((state: CollectionState) => ({ 
        collection: {...state.collection, [key]: value}
    })),
    setCollection: (collection: CollectionModel) => set((state: CollectionState) => ({ 
        collection: collection
    })),
    endDateCache: "",
    setEndDateCache: (collection: string) => set((state: CollectionState) => ({ 
        endDateCache: collection
    })),
}));

export default useCollections;